
import httpClient from 'httpClient';
import React, { useCallback, useEffect, useState } from 'react';

import AllResourceLinks from './allResourceLinks';
import AllImages from './allImages';

const AllResources = (props) => {
  
  const [links, setLinks] = useState([]);
  const [images, setImages] = useState([]);
  

  const getAssets = useCallback(async () => {
    
    const payload = {
      type:props.type,
      unit: props.unit,
      biomarker: props.biomarker,
    }
    if(!props.unit || !props.biomarker || !props.type) {
      return false;
    }
    try {
      const response = await httpClient.post(
        '/administration/v1/getAllHazardResources', payload
      )
      // console.log(response);
      if(!response.error) {
        setLinks(response.links);
        setImages(response.images);
      }
    } catch (ex) {

    } finally {
      
    }
    

  },[props.unit, props.biomarker]);

  const onLinkSaved = (link) => {
    const newLinks = [...links];
    const newLink = {
      url: link.url,
      description: link.description,
      id: link.id
    };
    let idFoundIdx = newLinks.findIndex(obj => obj.id === newLink.id);
    
    if(idFoundIdx === -1) {
      newLinks.push(newLink);  
    } else {
      newLinks[idFoundIdx] = newLink;
    }
    
    setLinks(newLinks);
  }

  const onLinkDeleted = (linkId) => {
    // console.log(`link deleted ${linkId}`)
  }

  useEffect(()=>{
    getAssets()
  },[getAssets])
  return ( 
    <div>
      <div>
        <AllResourceLinks
          links={links}
          onLinkSaved={onLinkSaved}
          onLinkDeleted={onLinkDeleted}
          unit = {props.unit}
          biomarker = {props.biomarker}
          type={props.type}
        />
      </div>

      <div>
        <AllImages
          unit = {props.unit}
          biomarker = {props.biomarker}
          type={props.type}
        />
      </div>
      
    </div>
  ) 
}

export default AllResources;